import {createGlobalStyle} from "styled-components"

export const GlobalStyles = createGlobalStyle`
    *{
        font-family: 'Inter', sans-serif;
    }
    #render-container{
        width: 100% !important;
        height: 100% !important;
    }
`
